import React, { useState } from 'react';
import { Heading, PropertyGroup, IconArrowHead } from '../../components';
import { languagesHelper as language } from '../../util/languages';
import { useIntl } from '../../util/reactIntl';

import css from './ListingPage.module.css';

const SectionMultiEnumMaybe = props => {
  const { 
    heading, 
    options, 
    selectedOptions, 
    showUnselectedOptions = true, 
    id, 
    propertyGroupClass 
  } = props;
  const hasContent = showUnselectedOptions || selectedOptions?.length > 0;
  if (!heading || !options || !hasContent) {
    return null;
  }
  const intl = useIntl();
  const [showSection, setShowSection] = useState(true);

  return (
    <section className={css.section}>
      <Heading as="h2" rootClassName={css.sectionTitle} onClick={() => setShowSection(!showSection)}>
        {language.labelsTranslator(id, intl)}
        <IconArrowHead direction={showSection ? "up" : "down"} />
      </Heading>

      {showSection && (
        <PropertyGroup
          id="ListingPage.amenities"
          options={options}
          selectedOptions={selectedOptions}
          twoColumns={options.length > 5}
          showUnselectedOptions={showUnselectedOptions}
          useTranslations
          className={propertyGroupClass}
        />
      )}
    </section>
  );
};

export default SectionMultiEnumMaybe;
